import React, { Component } from 'react';
import { storageKeys } from 'settings';
import { SubApp, StorageHandler } from 'C4';

export default class SubAppView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
      chapterId: -1,
      email: '',
    };
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
    document.body.classList.remove('subApp');
  }

  async init() {
    const { global } = (await StorageHandler.load(storageKeys.activeSubApp)) || {};

    const { appId, chapterId, email, pageId, type } = global;

    this.setState({
      appId,
      chapterId,
      email,
      pageId,
      type,
    });
  }

  render() {
    const { appId, chapterId, email, pageId, type } = this.state;

    console.log({ appId });

    return (
      <div>
        {appId > 0 && <SubApp appId={+appId} email={email} chapterId={chapterId} pageId={pageId} type={type} />}
      </div>
    );
  }
}
